<template>
    <div class="flex flex-col gap-2 items-start">
        <div>
            <label class="text-neutral-600 dark:text-neutral-400 text-xs">Modo</label>
            <div class="flex gap-1">
                <UButton label="Claro" color="neutral" variant="subtle" :active="!isDark" active-variant="subtle"
                    @click="colorMode.preference = 'light'" size="sm" icon="i-heroicons-sun-20-solid" />
                <UButton label="Escuro" color="neutral" variant="subtle" :active="isDark" active-variant="subtle"
                    @click="colorMode.preference = 'dark'" size="sm" icon="i-heroicons-moon-20-solid" />
            </div>
        </div>
    </div>
</template>

<script setup>
const colorMode = useColorMode()
const isDark = computed(() => colorMode.value === 'dark')
</script>
